<template>
  <v-data-table
    :headers="cabecalhos"
    :items="PRODUTOS_COMPUTED"
    hide-default-footer
    class="font-resp-tabela"
    :items-per-page="-1"
    fixed-header
    height="calc(100vh - 500px)"
  >
    <template #item.fator_conversao="{ item }">
      <SysInputFormatadorDeValor
        v-model="item.fator_conversao"
        class="input-regular"
        centralizar
        @focus="ev => ev.target.select()"
      />
    </template>

    <template #item.descricao_produto="{ item }">
      <div class="d-flex align-center text-left">
        <DetalhesProduto
          :produto="{id_grupo: ID_GRUPO_COMPRA_COMPUTED, id_filial: 9999, id_produto: item.idproduto}"
          class="ml-n2"
        />
        {{ item.descricao_produto }}
      </div>
    </template>

    <template #item.estoque="{ item }">
      {{ Helpers.formatarValor(item.estoque / (item.fator_conversao || 1)) }}
    </template>

    <template #item.consumo_medio_mensal="{ item }">
      {{ Helpers.formatarValor(item.consumo_medio_mensal / (item.fator_conversao || 1)) }}
    </template>

    <template #item.produto_pai="{ item }">
      <v-checkbox v-model="item.produto_pai" hide-details></v-checkbox>
    </template>
  </v-data-table>
</template>

<script>
import api from "@/api/api";
import {logout} from "@/helpers";
import {computed, onMounted} from "vue";
import store from "@/store";
import SysInputFormatadorDeValor from "@/components/utils/InputFormatadorDeValor.vue";
import DetalhesProduto from "@/components/produto/detalhes/Index.vue";

export default {
  name: "FatorConversaoProdutos",
  components: {DetalhesProduto, SysInputFormatadorDeValor},
  model: {
    prop: 'modelValue',
    event: 'update:modelValue',
  },
  props: {
    modelValue: Array,
    produtos: Array,
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const cabecalhos = [
      { text: 'ID Produto', value: 'idproduto' },
      { text: 'Descrição Produto', value: 'descricao_produto' },
      { text: 'Unidade Medida', value: 'idunidade_medida' },
      { text: 'Fator Conversão', value: 'fator_conversao' },
      { text: 'Estoque', value: 'estoque' },
      { text: 'Projeção de Vendas', value: 'consumo_medio_mensal' },
      { text: 'Item Pai', value: 'produto_pai' },
    ];

    const PRODUTOS_COMPUTED = computed({
      get: () => props.modelValue,
      set: valor => emit('update:modelValue', valor),
    });

    const ID_GRUPO_COMPRA_COMPUTED =  computed(() => store.getters['usuario/getGrupoCompras']);

    onMounted(buscarProdutos)

    function buscarProdutos() {
      const params = {
        idgrupo: ID_GRUPO_COMPRA_COMPUTED.value,
        produtos: props.produtos,
      };

      api.get('produtos/demanda-combinada/fator-conversao', { params })
        .then(resposta => PRODUTOS_COMPUTED.value = resposta.data.produtos)
        .catch(logout)
    }

    return {
      cabecalhos,
      PRODUTOS_COMPUTED,
      ID_GRUPO_COMPRA_COMPUTED,
    }
  }
}
</script>
